module.exports = __webpack_public_path__ + "img/01-Sticker.9f3c0cab.png";